import React from 'react';
import { Icons } from './Icons';
import './StatsBar.css';

export default function StatsBar({ stats }) {
  const cards = [
    { label: 'Companies', value: stats.totalCompanies, icon: <Icons.Building size={18} />, color: 'sage' },
    { label: 'Roles', value: stats.totalRoles, icon: <Icons.Briefcase size={18} />, color: 'blue' },
    { label: 'Contacts', value: stats.totalContacts, icon: <Icons.Users size={18} />, color: 'purple' },
    { label: 'Connected', value: stats.connectedContacts, icon: <Icons.Link size={18} />, color: 'green' },
  ];

  return (
    <div className="stats-bar">
      <div className="stats-inner">
        {cards.map(card => (
          <div key={card.label} className={`stat-card stat-${card.color}`}>
            <div className="stat-icon">{card.icon}</div>
            <div className="stat-info">
              <span className="stat-value">{card.value}</span>
              <span className="stat-label">{card.label}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
